import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { ReduxAsyncConnect } from 'redux-connect';
import reloadOnPropsChange from './utils/reloadOnPropsChange';

export default function Root({ numHotReloads, store, routes, baseProps }) {
  const props = {
    ...baseProps,
    store,
  };

  return (
    <Provider store={store}>
      <Router keyLength={numHotReloads}>
        <ReduxAsyncConnect
          routes={routes}
          render={() => renderRoutes(routes, props)}
          reloadOnPropsChange={reloadOnPropsChange}
        />
      </Router>
    </Provider>
  );
}

Root.propTypes = {
  numHotReloads: PropTypes.number.isRequired,
  baseProps: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  routes: PropTypes.array.isRequired,
};
